<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <i :class="twJoin(`icon icon-${props.name}`, props.class)" />
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
import type { CaseclubIconsId } from '@/public/fonts/CaseClubFontIcons/caseclub-icons'
import type { CSSProperties } from 'vue'

interface IconType {
  name: string | CaseclubIconsId
  rotate?: CSSProperties['transform']
  class?: string
}

const props = defineProps<IconType>()
</script>
